<template>
    <b-container fluid class="">
        <b-row>
            <b-col>
                <h3>{{$t('print_jobs.title')}}</h3>
            </b-col>
        </b-row>
        
        <hr/>

    <b-container fluid class="dashboardTile p-4 shadow-lg">
        <b-row v-if="printJobs">
            <b-col>
                <events-table position
                              search-key="name"
                              :items="printJobs"
                              :fields="printFields"
                              @rowClicked="">
                </events-table>
            </b-col>
        </b-row>
    </b-container>


    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'printJobs',
        data() {
            return {
                printJobs: null,
                printableTickets: 0,
                printFields: [
                    {
                        key: 'name',
                        labelPath: 'table.print.name',
                        sortable: true
                    },
                    {
                        key: 'total_printed2',
                        labelPath: 'table.print.printed',
                        sortable: true
                    },
                    {
                        key: 'total',
                        labelPath: 'table.print.total',
                        sortable: true
                    },
                ],
            }
        },
        methods: {
            getPrintJobs(){
                this.$axios.get('printJobs').then(response => {
                    if (response.data.success) {
                        this.printJobs = response.data.data;
                    }
                })
            },

        },
        created() {
            let self = this;
            this.getPrintJobs();
            this.interval = setInterval(function () {
                self.getPrintJobs();
            }, 5000);

        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>
